import Vue from 'vue'
import VueRouter from 'vue-router'
import Auth from '@/auth/Auth'
import Site from '@/views/Site'
import Home from '@/views/Home'
import Empresas from '@/views/Empresas'
import Usuarios from '@/views/Usuarios'
import Chamadores from '@/views/Chamadores'
import Paineis from '@/views/Paineis'
import Chamados from '@/views/Chamados'
import Painel from '@/views/Painel'
import { userKey } from '@/global'

Vue.use(VueRouter)

const routes = [
  { name: 'site', path: '/', component: Site, meta: { requiresAdmin: false } },
  { name: 'auth', path: '/login', component: Auth, meta: { requiresAdmin: false } },
  { name: 'home', path: '/home', component: Home, meta: { requiresAdmin: true } },
  { name: 'empresas', path: '/empresas', component: Empresas, meta: { requiresAdmin: true } },
  { name: 'usuarios', path: '/usuarios', component: Usuarios, meta: { requiresAdmin: true } },
  { name: 'chamadores', path: '/chamadores', component: Chamadores, meta: { requiresAdmin: true } },
  { name: 'paineis', path: '/paineis', component: Paineis, meta: { requiresAdmin: true } },
  { name: 'chamados', path: '/chamados', component: Chamados, meta: { requiresAdmin: true } },
  { name: 'painel', path: '/painel', component: Painel, meta: { requiresAdmin: true } },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

//Controla segurança de rotas
router.beforeEach((to, from, next) => {
  const json = sessionStorage.getItem(userKey)
  if (to.matched.some(record => record.meta.requiresAdmin)) {
    const user = JSON.parse(json)
    if (user === "GERENTE" || user === "ADMIN" || user === 'ENFERMAGEM')
      next()
    else
      next({ path: '/login' })
  } else {
    next()
  }
})

export default router